export default "__VITE_ASSET__35842418__"